import Vue from 'vue';
import {HTTP} from "@/utils/httpCommonUtil";
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner';
import {getRestParamErrorMessage} from '@/utils/serverErrorMessageUtil';
import HttpMixin from '@/mixins/HttpMixin';

export default Vue.component('notes-card', {
  props: {
    noteType: { type: Number },
    entityId: { type: [Number, String] },
    cardTitle: { type: String, default: 'Notes' }
  },
  name: 'NotesCard',
  data () {
    return {
      cardExpanded: false,
      saving: false,
      notes: [] as any[],
      noteErrorMessage: '',
      url: ''
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
  },
  mixins: [ HttpMixin ],
  created () {
    this.url = `/notes/types/${this.noteType}/entities/${this.entityId}`;
  },
  methods: {
    async expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.getNotes()
      }
    },
    async getNotes () {
      const data = await (this as any).httpGet(this.url, 'Failed to retrieve Notes.') || [];
      this.notes = data.map( (note: any) => {
        note.isNew = false;
        note.note = note.note.trim();
        return note;
      });
    },
    async saveNote (newNote: any) {
      this.saving = true;
      try {
        await HTTP.post('/api' + this.url, newNote);
        this.saving = false;
        await this.getNotes();
      } catch (err) {
        this.saving = false;
        this.noteErrorMessage = getRestParamErrorMessage(err, 'note');

        if (!this.noteErrorMessage) {
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: 'An error occurred saving note.'
          });
        }
      }
    },
    addNote () {
      const toDelete = this.notes
        .map((note: any, index: number) => note.isNew ? index : -1)
        .filter(index => index > -1);
      toDelete.forEach((index: number) => this.notes.splice(index,1));

      this.notes.unshift(
        {
          note: "",
          isNew: true,
          isEditing: true
        }
      );
      // We have to set it after a delay or it gets unset by animation/etc.
      window.setTimeout(() => {
        // The ref is an array because it's in a v-for
        (this.$refs.noteTextArea as HTMLInputElement[])[0].focus();
      }, 100);
    },
    async cancel () {
      this.notes[0].isEditing = false;
      // Allow the editing UI to collapse before removing it from the array
      setTimeout(() => this.notes.shift(), 300);
    }
  }
})



// WEBPACK FOOTER //
// ./src/componentsReusable/cards/NotesCard.ts